<div
  class="container p-6 bg-card shadow-gray-400 shadow-[0_0px_60px_-15px_rgba(0,0,0,0.3)]"
  [class.open]="open">
  <div class="flex justify-between">
    <!-- close -->
    <button
      mat-icon-button
      aria-label="close"
      (click)="open = false; close.next(false)"
      type="button">
      <mat-icon class="icon-size-17 fa-regular fa-arrow-left"></mat-icon>
    </button>

    <div class="justify-center w-full text-lg text-gray-500 flex items-center">
      {{ title | translate }}
    </div>
  </div>

  <!-- body -->
  <div class="scroll scroll-none">
    <!-- Message -->
    <treo-message
      class="mb-5"
      [appearance]="message.appearance"
      [showIcon]="message.showIcon"
      [showButtonClose]="message.showButtonClose"
      [type]="message.type"
      *ngIf="message">
      <i
        treoMessageIcon
        [class]="message.customIcon"
        *ngIf="message.customIcon"></i>
      <div treoMessageTitle *ngIf="message.title">
        {{ message.title | translate }}
      </div>
      <div *ngIf="getContentType(message.content) == 'string'">
        {{ message.content | translate }}
      </div>
      <ul
        class="list-disc pl-3 text-left"
        *ngIf="getContentType(message.content) == 'array'">
        <li *ngFor="let item of message.content">{{ item | translate }}</li>
      </ul>
    </treo-message>

    <ng-content></ng-content>
  </div>
</div>

<div
  class="overlay"
  *ngIf="open"
  (click)="open = false; close.next(false)"></div>
